import { useToast } from '@chakra-ui/react';
import { useQuery } from 'react-query';
import { stepPedidoData } from '../../pages/certificados/NovoCertificado/Steps/Pedido/index';
import backend from '../backend';

// tipagem do retorno do request
interface IResponseData {
  id_produto: string;
  descricao: string;
}

// tipagem do que o hook retorna
type ICertificadosReponse = IResponseData[];

async function getProdutoCert(
  data: stepPedidoData,
): Promise<ICertificadosReponse> {
  const response = await backend.get<IResponseData>('/ProdutoCert', {
    params: data,
  });

  return [response.data];
}

export function useProdutoCert(data: stepPedidoData) {
  const toast = useToast();
  return useQuery(['produto-cert', data], () => getProdutoCert(data), {
    // staleTime: 1000 * 60 * 5,
    // cacheTime: 1000 * 60 * 5,
    // refetchOnWindowFocus: false,
    onError: (error: any) => {
      if (error.response) {
        toast({
          title: 'Erro ao buscar Produto',
          description: error.response.data.error,
          status: 'error',
          duration: 4000,
          isClosable: true,
          position: 'bottom-right',
        });
      }
    },
  });
}
